///<reference path="sharedEnvironments-module.ts"/>
module Shared.Environments {

    export class EnvironmentsDataService {

        private dataPromise: ng.IPromise<IEnvironmentData[]>;

        static $inject = ["$http", "$q"];
        constructor(private $http: ng.IHttpService, private $q: ng.IQService) {}

        public all(): ng.IPromise<IEnvironmentData[]> {
            if (this.dataPromise) {
                return this.dataPromise;
            }

            var deferred = this.$q.defer<IEnvironmentData[]>();
            this.$http.get("EnvironmentsActions/GetEnvironments")
                .then((response: any) => {
                    if (response && response.data.success) {
                        deferred.resolve(response.data.data);
                    } else {
                        deferred.reject(response.data && response.data.errorMessage);
                    }
                }).
                catch(reason => deferred.reject(reason));
            this.dataPromise = deferred.promise;

            return this.dataPromise;
        }
    }

    module.service("EnvironmentsDataService", EnvironmentsDataService);

    export interface IEnvironmentData {
        id: number;
        name: string;
        displayName: string;
        agentGroups: IAgentGroupData[];
    }

    export interface IAgentGroupData {
        id: number;
        name: string;
        displayName: string;
        connectionString: string;
        executionAgents: IAgentData[];
        gatewayAgents: IAgentData[];
        configJson: string;
    }

    export interface IAgentData {
        name: string;
    }
}